import { EditTable } from "./lib/edit_table.js";
import { setupPlanPricesButtons } from './lib/plan_prices_modal';

$(document).on('turbo:load', function() {
  if ($("body.accounts_plans.edit").length == 0) {
    return;
  }
  console.log("page load in plans_edit.js");

  setupHosterFilterSubmit();
  setupPlanPricesButtons();

  var plans_edit_page = new EditTable(true, '/accounts/plans');
  plans_edit_page.init();
} );

function setupHosterFilterSubmit() {
  $('#hoster-filter-select').on('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      $(event.target).closest('form').trigger('submit');
    }
  });
}
